import { Component, input } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-risk-legend',
    templateUrl: './risk-legend.component.html',
    styleUrl: './risk-legend.component.scss',
    imports: [TranslatePipe],
})
export class RiskLegendComponent {
  isVarietyProperties = input<boolean>(false);

}
